module.exports = __webpack_public_path__ + "img/product-program-yszc-icon2.9fb2b415.png";